module.exports = __webpack_public_path__ + "img/blue_circle.fe7ad587.png";